import styled from 'styled-components';
import { ButtonPrimary, ButtonTertiary } from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';

const StyledButtonPrimary = styled(ButtonPrimary)`
  cursor: pointer;
`;

const StyledButtonTertiary = styled(ButtonTertiary)`
  cursor: pointer;
`;

interface FooterButtonsProps {
  onClose: () => void;
  submitButtonDisabled: boolean;
  isFetched: boolean;
  lastBtnRef: React.MutableRefObject<HTMLElement | null>;
}
export const FooterButtons = ({
  onClose,
  submitButtonDisabled,
  isFetched,
  lastBtnRef,
}: FooterButtonsProps) => {
  const t = useT();

  return (
    <>
      <StyledButtonTertiary
        type="button"
        buttonSize="sm"
        condensed
        onClick={onClose}
      >
        {t('atlas.actions.close', 'Close', 'Action to close')}
      </StyledButtonTertiary>
      {!isFetched && (
        <StyledButtonPrimary
          ref={lastBtnRef}
          buttonSize="sm"
          type="submit"
          data-cy="submit"
          disabled={submitButtonDisabled}
        >
          {t('atlas.actions.submit', 'Submit', 'Action to submit form')}
        </StyledButtonPrimary>
      )}
    </>
  );
};
